function isWireless(classOfService: string): boolean {
    return (
        classOfService === 'MOBL' ||
        classOfService === 'WRLS' ||
        classOfService === 'WPH1' ||
        classOfService === 'W911' ||
        classOfService === 'WPH2'
    );
}

function isWirelessPhaseOne(classOfService: string): boolean {
    return (
        classOfService === 'MOBL' ||
        classOfService === 'WRLS' ||
        classOfService === 'WPH1' ||
        classOfService === 'W911'
    );
}

export function isWirelessPhaseTwo(classOfService: string): boolean {
    return classOfService === 'WPH2';
}

export function getCallerAddressLabel(classOfService?: string) {
    return !!classOfService && isWireless(classOfService) ? 'Cell Tower' : 'Address';
}

export function getCallSource(classOfService: string): string {
    if (isWirelessPhaseTwo(classOfService)) {
        return 'CALLER GPS';
    } else if (isWirelessPhaseOne(classOfService)) {
        return 'CELL TOWER';
    }
    return 'LANDLINE';
}
